export const Profile = () => (
    <>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2.25C9.37665 2.25 7.25 4.37665 7.25 7C7.25 9.62335 9.37665 11.75 12 11.75C14.6234 11.75 16.75 9.62335 16.75 7C16.75 4.37665 14.6234 2.25 12 2.25ZM8.75 7C8.75 5.20507 10.2051 3.75 12 3.75C13.7949 3.75 15.25 5.20507 15.25 7C15.25 8.79493 13.7949 10.25 12 10.25C10.2051 10.25 8.75 8.79493 8.75 7Z"
            fill="black"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 14.25C4.58579 14.25 4.25 14.5858 4.25 15V17C4.25 18.2775 4.89863 19.5005 6.20897 20.374C7.49931 21.2343 9.41232 21.75 12 21.75C14.5877 21.75 16.5007 21.2343 17.791 20.374C19.1014 19.5005 19.75 18.2775 19.75 17V15C19.75 14.5858 19.4142 14.25 19 14.25H5ZM5.75 17V15.75H18.25V17C18.25 17.7225 17.8986 18.4995 16.959 19.126C15.9993 19.7657 14.4123 20.25 12 20.25C9.58768 20.25 8.00069 19.7657 7.04103 19.126C6.10137 18.4995 5.75 17.7225 5.75 17Z"
            fill="black"
        />
    </>
);

Profile.viewBox = '0 0 24 24';
